import { Tag, TagProps } from "@chakra-ui/react";
import { actionSummaryStatusInfo, fromActionPrefixId } from "features/Resources/Shared/helpers";
import { ActionV2, ActionSummary } from "features/Resources/Shared/models";

interface SendDateWithImmediateTagProps extends TagProps {
  action: ActionSummary | ActionV2;
}

export default function ActionSummaryStatusTag({ action, ...rest }: SendDateWithImmediateTagProps) {
  if (!action) {
    return null;
  }
  let referenceAction = action;
  if (!(action as ActionSummary)?.actionType) {
    const { resourceType } = fromActionPrefixId((action as ActionV2)?.prefixId);
    referenceAction = { actionType: resourceType, action: (action as ActionV2) };
  }
  const actionStatus = actionSummaryStatusInfo(referenceAction);
  const { text } = actionStatus;
  // Only returns Sent, Error, Skipped, Immediate
  if (!text) {
    return null;
  }

  return (
    <Tag
      borderRadius="md"
      boxShadow="none"
      {...actionStatus.colorScheme}
      {...rest}
    >
      {text}
    </Tag>
  );
}
